
































import { Component, Vue } from 'vue-property-decorator'
import { State, Getter, Action, Mutation } from '../store-helper'
import ExamRevision from '../../api/v2/models/exam_revision'
import RevisionItemComponent from './RevisionItemComponent.vue'
import { format } from 'date-fns'
import { uniq } from 'lodash'
import { qEditorState } from '../stores'

@Component({
  components: {
    RevisionItemComponent
  }
})
export default class RevisionComponent extends Vue {
  get examRevisions(){
    return qEditorState.examRevisions
  }
  get currentExamRevision(){
    return qEditorState.currentExamRevision
  }

  get examRevisionGroups(): {
    date: string
    examRevisions: ExamRevision[]
  }[] {
    const groups = []
    const examRevisionsDate = uniq(
      this.examRevisions.map((item) => {
        return format(item.createdAt, 'MM/DD/YYYY')
      })
    )

    return examRevisionsDate.map((item) => {
      return {
        date: item,
        examRevisions: this.examRevisions.filter((examRevision) => format(examRevision.createdAt, 'MM/DD/YYYY') == item)
      }
    })
  }

  setExamRevision(){
    qEditorState.setExamRevision()
  }
}
